export default "__VITE_ASSET__RZHpyYuX__"